import Widget from 'components/Widget/Widget';
import React from 'react';
import ProfitsAndLossesByChannelsTable from './components/ProfitsAndLossesByChannelsTable';

const ProfitsAndLossesByChannel = ({ height, data, index, configuration }) => {
  return (
    <Widget
      tableWidget
      widget_key={'channelsProfitAndLoss' + index}
      title={data.title}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      disableAccountsFilter
      configuration={configuration}
      adsFilter
      adsetFilter
      campaignFilter
      showDatePicker
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <ProfitsAndLossesByChannelsTable
        height={height}
        widget_key={'channelsProfitAndLoss' + index}
      />
    </Widget>
  );
};

export default ProfitsAndLossesByChannel;
